module.exports = __webpack_public_path__ + "img/pistol.af74ddcc.gif";